export default __webpack_public_path__ + "static/media/CR_intro_video_still.3479adb9.png";